jQuery(function($){
  var $icon    = $('.navbar-toggler.animated-icon2');
  var $modalEl = $('#mobile-menu-modal');
  var modal    = new bootstrap.Modal( $modalEl[0] );

  $('[data-bs-toggle="popover"]').each(function(){
    new bootstrap.Popover(this);
  });

  $icon.on('click', function(){
    $(this).toggleClass('open');
    $modalEl.hasClass('show') ? modal.hide() : modal.show();
  });

  $modalEl.on('hidden.bs.modal', function(){
    $icon.removeClass('open');
  });

  $modalEl.on('click', '.nav-link:not(.dropdown-toggle)', function(){
    modal.hide();
    $icon.removeClass('open');
  });

  $modalEl.on('click', function(e){
    if ( $(e.target).closest('.navbar-nav').length === 0 ) {
      modal.hide();
      $icon.removeClass('open');
    }
  });

  // —————— your search expand/collapse + shrink‐menu code ——————
  var $searchItem  = $('.search-item'),
      $searchForm  = $searchItem.find('.search-form'),
      $searchInput = $searchItem.find('.search-input'),
      $navWrapper  = $('#menu-header-menu'); // or '.navbar-nav' if that's your selector

  // expand search + shrink other items
  $searchForm.on('click', function(e){
    e.stopPropagation();
    $searchItem.addClass('search-active');
    $navWrapper.addClass('shrink-menu');
    $searchInput.focus();
  });

  // collapse on blur or click outside
  function collapseSearch(){
    $searchItem.removeClass('search-active');
    $navWrapper.removeClass('shrink-menu');
  }

  $searchInput.on('blur', collapseSearch);
  $(document).on('click', collapseSearch);
});